import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import styles from './comingsoon.module.css';
import Navbar from '../../navbar/Navbar';
import Footer from '../../footer/Footer';

const Demo = () => {
  return (
    /* Change 1: demoPageWrapper ensures a standard top-to-bottom flow */
    <div className={styles.demoPageWrapper}>
      <Navbar />
      
      {/* Change 2: This section handles the centered video content */}
      <section className={styles.demoSection}>
        <div className={styles.container}>
          <Typography variant="h2" className={styles.mainTitle}>
            Coming Soon....!
          </Typography>

          

        

          <Box className={styles.buttonWrapper}>
            <Button 
              variant="contained" 
              className={styles.generateButton}
              onClick={() => window.location.href = '/'}
            >
              GO to Home
            </Button>
          </Box>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Demo;